import styles from './FJScriptEditorInput.module.less';
import FJRichTextEditor from '../../../common/components/FJRichTextEditor/FJRichTextEditor';
import PropTypes from 'prop-types';
import { TEXT_TO_VIDEO_PRICE, TEXT_TO_VIDEO_TEMPLATE_LIST } from '../../../config/dataConfig/FJTextToVideoDataConfig';
import { useCallback, useEffect } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJUtil from '../../../util/FJUtil';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import classNames from 'classnames';
import FJFreeTimesSpan from '../FJFreeTimesSpan/FJFreeTimesSpan';
const INIT_NODES = [
    {
        type: 'paragraph',
        children: [
            {
                text: '',
            },
        ],
    },
];
const FJScriptEditorInput = props => {
    const { slateEditorNodes, setSlateEditorNodes, onGenerateScript, freeTimes, creditNumber, isEditScript } = props;
    const isFree = freeTimes > 0 && creditNumber < TEXT_TO_VIDEO_PRICE.textToScript;
    // 转化为本地化
    const __localData = useCallback(data => {
        let textData = {};
        Object.keys(data).forEach(key => {
            if (Array.isArray(data[key])) {
                textData[key] = data[key].map(item => item.map(i => FJLocalStore._(i)));
            } else {
                textData[key] = FJLocalStore._(data[key]);
            }
        });
        return textData;
    }, []);

    useEffect(() => {
        const initData = slateEditorNodes.length ? slateEditorNodes : INIT_NODES;

        setSlateEditorNodes(initData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setSlateEditorNodes, __localData]);

    const _onSampleChange = useCallback(
        item => {
            setSlateEditorNodes(FJUtil.convertToSlateNodes(__localData(item)));
        },
        [setSlateEditorNodes, __localData],
    );

    return (
        <div
            className={classNames(styles.script_editor_box, isEditScript && styles.edit_script)}
            id='script-editor-input'
        >
            <div className={styles.input_box}>
                <FJRichTextEditor
                    value={slateEditorNodes}
                    onChange={setSlateEditorNodes}
                    placeholder={FJLocalStore._('describe-the-video-you-want-to-generate')}
                    maxHeight={58}
                />
            </div>
            <div className={classNames(styles.input_box_bottom, isEditScript && styles.btn_show)}>
                <div className={styles.sample_list}>
                    <span className={styles.sample_title}>{FJLocalStore._('sample-desc')}</span>
                    {TEXT_TO_VIDEO_TEMPLATE_LIST.map(item => (
                        <span
                            className={styles.sample_item}
                            key={item.templateName}
                            onClick={() => _onSampleChange(item)}
                        >
                            {FJLocalStore._(item.templateName)}
                        </span>
                    ))}
                </div>
                {isEditScript && (
                    <div className={styles.generate_btn_box}>
                        {isFree && <FJFreeTimesSpan times={freeTimes} className={styles.free_times_span} />}
                        <FJGenerateButton
                            text={FJLocalStore._('generate')}
                            className={styles.generate_btn}
                            onClick={onGenerateScript}
                            isFree={isFree}
                            useCredit={TEXT_TO_VIDEO_PRICE.textToScript}
                            hideFreeCreation={true}
                            useCreditClassName={styles.use_credit}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

FJScriptEditorInput.propTypes = {
    setInputData: PropTypes.func,
    setInputText: PropTypes.func,
    slateEditorNodes: PropTypes.array,
    setSlateEditorNodes: PropTypes.func,
    onGenerateScript: PropTypes.func,
    freeTimes: PropTypes.number,
    creditNumber: PropTypes.number,
    isEditScript: PropTypes.bool,
};

export default FJScriptEditorInput;
